export default "__VITE_ASSET__C0KjP_F6__"